import { Order } from '../../../../types/general.types';

// The folders that hold a record's own papers lead every level they sit in.
const PINNED_FOLDER_NAMES = ['General', 'Documents'];

type NamedFolder = { name: string };

const isPinned = ({ name }: NamedFolder): boolean => PINNED_FOLDER_NAMES.includes(name);

const compareNames = (left: NamedFolder, right: NamedFolder): number =>
  left.name.localeCompare(right.name, undefined, { sensitivity: 'base' });

// General and Documents first, the rest in the order they came.
export const withPinnedVaultFoldersFirst = <Folder extends NamedFolder>(
  folders: Folder[],
): Folder[] => {
  if (!folders.some(isPinned)) return folders;

  return [...folders.filter(isPinned), ...folders.filter((folder) => !isPinned(folder))];
};

/**
 * A Vault level by name, whatever the database's collation makes of it, with General and
 * Documents leading it in either direction. Equal names keep the server's order.
 */
export const inVaultNameOrder = <Folder extends NamedFolder>(
  folders: Folder[],
  order: Order = Order.ASC,
): Folder[] => {
  const sorted = [...folders].sort((left, right) =>
    order === Order.DESC ? compareNames(right, left) : compareNames(left, right),
  );

  return withPinnedVaultFoldersFirst(sorted);
};
